import {
    Component,
    computed,
    DestroyRef,
    inject,
    input,
    OnInit,
    output,
    signal,
} from '@angular/core';
import { DepositFormDataService } from '../../deposit-form-data.service';
import { SortUtils } from '../../../shared/utils/sort.utils';
import { AutoPopulateKeys } from '../../../shared/configurations/auto-populate-keys.config';
import { ConfigurationHandlerService } from '../../../core/configuration-handler.service';
import { CustomTranslatePipe } from '../../../shared/pipes/custom-translate.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'esp-deposit-publication-status',
    templateUrl: './deposit-publication-status.component.html',
    styleUrls: ['./deposit-publication-status.component.scss'],
    imports: [
        MatIcon,
        MatTooltip,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        CustomTranslatePipe,
    ],
})
export class DepositPublicationStatusComponent implements OnInit {
    dataSvc = inject(DepositFormDataService);
    readonly selectedStatus = output<any>();
    readonly label = input<string>(undefined);
    readonly hint = input<string>(undefined);
    readonly placeholder = input<string>(undefined);
    readonly autoPopulated = input(false);
    readonly statusOptions = computed(() => {
        const cfg = this.configurationHandlerService.depositConfig();
        const resourceTypeTemplate = this.dataSvc.resourceTypeTemplate;
        return (
            cfg?.deposit?.[resourceTypeTemplate].statuses
                ?.filter((status) => status.mandatory)
                .map((status) => status.status)
                .sort(SortUtils.alphabeticallySort) || []
        );
    });

    private destroyRef = inject(DestroyRef);
    private configurationHandlerService = inject(ConfigurationHandlerService);

    ngOnInit() {
        this.dataSvc.status.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((value) => {
                this.selectedStatus.emit(value);
                if (!this.dataSvc.startPopulating) {
                    this.dataSvc.removeKeyFromAutoPopulatedArray(
                        AutoPopulateKeys.STATUS,
                    );
                }
            });
    }
}
